import React, { useEffect, useState } from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const WhatsApp = () => {
  const phone = "905426429466";
  const message = "Usta merhaba, motorumla ilgili bir sorunum var, yardımcı olur musun?";

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      {/* WhatsApp */}
      <a
        href={`https://wa.me/${phone}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          backgroundColor: '#25D366',
          color: 'white',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          textDecoration: 'none',
          transition: 'transform 0.25s ease, box-shadow 0.25s ease',
          boxShadow: `
            0 0 10px rgba(37, 211, 102, 0.6),
            0 0 25px rgba(37, 211, 102, 0.5),
            0 0 45px rgba(37, 211, 102, 0.4)
          `,
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <MessageCircle size={35} />
      </a>

      {/* 📱 SADECE MOBİL TELEFON BUTONU */}
      {isMobile && (
        <a
          href={`tel:+${phone}`}
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '30px',
            backgroundColor: '#5f130e',
            color: 'white',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            textDecoration: 'none',
            transition: 'transform 0.25s ease, box-shadow 0.25s ease',
            boxShadow: `
              0 0 10px rgba(255, 60, 60, 0.6),
              0 0 25px rgba(255, 60, 60, 0.4),
              0 0 45px rgba(255, 60, 60, 0.3)
            `,
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.12)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <Phone size={30} />
        </a>
      )}
    </>
  );
};

export default WhatsApp;
